import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { RoleEnum } from '@affiliation/enums';
import { BossApi, ChannelApi } from '~/api';
import { encryptText } from '~/plugins/crypto';
export var state = function state() {
	return {
		items: []
	};
};

export var mutations = {
	setList: function setList(state, items) {
		state.items = items.map(function (item) {
			return {
				name: item.Firstname + ' ' + item.Lastname,
				value: item.IdBoss,
				active: item.IsActive === 0 ? false : true,
				items: [],
				channels: item.Channels,
				type: 'Canales'
			};
		});
	},
	setBossChannels: function setBossChannels(state, _ref) {
		var idBoss = _ref.idBoss,
		    channels = _ref.channels;

		for (var i = 0; i < state.items.length; i++) {
			if (state.items[i].value === idBoss) {
				state.items[i].items = channels.map(function (item) {
					return {
						name: item.Name,
						active: item.IsActive === 0 ? false : true,
						id: item.IdChannel
					};
				});
				break;
			}
		}
	},
	updateStatusChannel: function updateStatusChannel(state, data) {
		for (var i = 0; i < state.items.length; i++) {
			// encontrar el jefe
			if (state.items[i].value === data.idBoss) {
				// encontrar el canal
				for (var j = 0; j < state.items[i].items.length; j++) {
					if (state.items[i].items[j].id === data.val.id) {
						state.items[i].items[j].active = data.val.status;
					}
				}
			}
		}
	},
	updateNumberChannels: function updateNumberChannels(state, data) {
		for (var i = 0; i < state.items.length; i++) {
			if (state.items[i].value == data) {
				var response = Number(state.items[i].channels) + 1;
				return state.items[i].channels = String(response);
			}
		}
	}
};

export var actions = {
	list: function () {
		var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
			var commit = _ref2.commit,
			    rootState = _ref2.rootState;
			var bosses;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return new BossApi(this.$axios).getListOfBoss({
								term: '',
								idRole: rootState.user.roleId
							});

						case 2:
							bosses = _context.sent;

							commit('setList', bosses);

						case 4:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function list(_x) {
			return _ref3.apply(this, arguments);
		}

		return list;
	}(),
	loadChannels: function () {
		var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4, idBoss) {
			var rootState = _ref4.rootState,
			    commit = _ref4.commit;
			var conditional, channels;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							conditional = rootState.roleId === RoleEnum.BOSS ? rootState.userId : idBoss;
							_context2.next = 3;
							return new ChannelApi(this.$axios).getChannelsManagement({
								idBoss: conditional,
								idRole: rootState.user.roleId,
								term: ''
							});

						case 3:
							channels = _context2.sent;

							commit('setBossChannels', { idBoss: idBoss, channels: channels });

						case 5:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function loadChannels(_x2, _x3) {
			return _ref5.apply(this, arguments);
		}

		return loadChannels;
	}(),
	createdNewBoss: function () {
		var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6, data) {
			var state = _ref6.state;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return new BossApi(this.$axios).createdNewBoss(data);

						case 2:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function createdNewBoss(_x4, _x5) {
			return _ref7.apply(this, arguments);
		}

		return createdNewBoss;
	}(),
	findBossById: function () {
		var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8, data) {
			var state = _ref8.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.prev = 0;
							_context4.next = 3;
							return new BossApi(this.$axios).findBossById({
								idBoss: data
							});

						case 3:
							response = _context4.sent;
							return _context4.abrupt('return', response);

						case 7:
							_context4.prev = 7;
							_context4.t0 = _context4['catch'](0);

						case 9:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, this, [[0, 7]]);
		}));

		function findBossById(_x6, _x7) {
			return _ref9.apply(this, arguments);
		}

		return findBossById;
	}(),
	editBoss: function () {
		var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10, data) {
			var state = _ref10.state,
			    dispatch = _ref10.dispatch;
			return _regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return new BossApi(this.$axios).editBoss(_extends({}, data, {
								idRole: RoleEnum.BOSS
							}));

						case 2:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function editBoss(_x8, _x9) {
			return _ref11.apply(this, arguments);
		}

		return editBoss;
	}(),
	validationBossEmail: function () {
		var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref12, data) {
			var state = _ref12.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return new BossApi(this.$axios).validationBossEmail({
								idUser: data.idUser,
								email: data.email
							});

						case 2:
							response = _context6.sent;
							return _context6.abrupt('return', response);

						case 4:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, this);
		}));

		function validationBossEmail(_x10, _x11) {
			return _ref13.apply(this, arguments);
		}

		return validationBossEmail;
	}(),
	validationDocumentNumberBoss: function () {
		var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref14, data) {
			var state = _ref14.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return new BossApi(this.$axios).validationDocumentNumberBoss({
								idUser: data.idUser,
								documentNumber: data.documentNumber
							});

						case 2:
							response = _context7.sent;
							return _context7.abrupt('return', response);

						case 4:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, this);
		}));

		function validationDocumentNumberBoss(_x12, _x13) {
			return _ref15.apply(this, arguments);
		}

		return validationDocumentNumberBoss;
	}(),
	validationPasswordBoss: function () {
		var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref16, data) {
			var dispatch = _ref16.dispatch,
			    rootState = _ref16.rootState;
			var cancellationToken;
			return _regeneratorRuntime.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.next = 2;
							return dispatch('getCancellationToken', null, { root: true });

						case 2:
							cancellationToken = _context8.sent;
							_context8.next = 5;
							return new BossApi(this.$axios).validationPasswordBoss({
								idUser: rootState.user.userId,
								password: encryptText(data.password)
							}, cancellationToken);

						case 5:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function validationPasswordBoss(_x14, _x15) {
			return _ref17.apply(this, arguments);
		}

		return validationPasswordBoss;
	}()
};


//////////////////
// WEBPACK FOOTER
// ./src/store/boss.js
// module id = ./src/store/boss.js
// module chunks = 34